import React, { useState, useEffect, useMemo } from 'react';
import { Typography, Tag } from 'antd';
import dayjs from 'dayjs';
import CrudPage from '../../../components/common/CrudPage';
import { contentVideoService, contentCategoryService } from '../../../services/cms/contentManagementService';

const { Text } = Typography;
const STATUS_OPTIONS = [{ label: 'Active', value: 1 }, { label: 'Inactive', value: 0 }];

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
  { title: 'TIÊU ĐỀ', dataIndex: 'title', key: 'title', render: (t) => <Text strong>{t}</Text> },
  { title: 'DANH MỤC', dataIndex: 'category_id', key: 'category_id', width: 150, render: (val, r) => r.category_name ? `[${val}] ${r.category_name}` : (val || '-') },
  { title: 'NGƯỜI TẠO', dataIndex: 'author_name', key: 'author_name', width: 140, render: (val, r) => val || r.create_by || r.created_by || '-' },
  { title: 'THUMB', dataIndex: 'img_thumb', key: 'img_thumb', width: 80, render: (u) => u ? <img src={u} alt="" style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4 }} /> : '-' },
  { title: 'NGÀY PHÁT HÀNH', dataIndex: 'publish_date', key: 'publish_date', width: 130, render: (t) => t ? dayjs(t).format('DD/MM/YYYY') : '-' },
  { title: 'TRẠNG THÁI', dataIndex: 'status', key: 'status', width: 100, render: (s) => <Tag color={s === 1 ? 'green' : 'red'}>{s === 1 ? 'ACTIVE' : 'INACTIVE'}</Tag> },
  { title: 'NGÀY TẠO', dataIndex: 'create_time', key: 'create_time', width: 140, render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-' },
];

const QuanLyVideoND = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    contentCategoryService.listActive().then((res) => {
      if (Array.isArray(res)) {
        setCategories(res.map((c) => ({ label: `[${c.id}] ${c.title}`, value: c.id })));
      }
    });
  }, []);

  const formFields = useMemo(() => [
    { name: 'title', label: 'Tiêu đề', type: 'input', rules: [{ required: true, message: 'Vui lòng nhập tiêu đề!' }] },
    // video.category_id là NOT NULL không default: bỏ trống là HTTP 500 ở DB (QA-01)
    { name: 'category_id', label: 'Danh mục', type: 'select', options: categories, rules: [{ required: true, message: 'Vui lòng chọn danh mục!' }], propsInput: { showSearch: true, optionFilterProp: 'label' } },
    { name: 'description', label: 'Mô tả', type: 'textarea' },
    { name: 'img_thumb', label: 'Thumbnail', type: 'upload-cdn' },
    { name: 'video_link', label: 'Link video', type: 'upload-file', uploadFolder: 'lichviet', maxSizeMB: 100, accept: 'video/*', placeholder: 'Nhập link hoặc bấm Upload để tải video lên (tối đa 100MB)' },
    { name: 'publish_date', label: 'Ngày phát hành', type: 'date', format: 'DD/MM/YYYY', submitFormat: 'YYYY-MM-DD HH:mm:ss' },
    { name: 'metadata', label: 'Metadata', type: 'textarea', propsInput: { rows: 2 } },
    { name: 'status', label: 'Trạng thái', type: 'select', options: STATUS_OPTIONS, defaultValue: 1 },
  ], [categories]);

  const filterFields = useMemo(() => [
    {
      label: 'Chọn danh mục',
      value: 'category_id',
      options: [{ label: 'Tất cả danh mục', value: '' }, ...categories],
    },
    {
      label: 'Ngày phát hành',
      value: 'publish_date',
      type: 'date',
      // Giống CMS cũ: publish_date = 'YYYY-MM-DD'
      submitFormat: 'YYYY-MM-DD',
    },
  ], [categories]);

  return (
    <CrudPage
      title="QUẢN LÝ VIDEO"
      subTitle="Quản lý video nội dung"
      itemsName="Video"
      queryKey="contentVideoList"
      service={contentVideoService}
      columns={columns}
      formFields={formFields}
      filterFields={filterFields}
      searchPlaceholder="Tìm kiếm theo tiêu đề..."
      addButtonLabel="Thêm video"
    />
  );
};

export default QuanLyVideoND;
